import { MediaLocale } from "@/locales/localeid";
import { MediaSlot, MediaType } from "@/util/enum";

export const MediaSlotBinding = {
	[MediaSlot.ViewingContent]: MediaLocale.MediaViewingContentText,
	[MediaSlot.AlternateContent]: MediaLocale.MediaAlternateContentText,
	[MediaSlot.Audio]: MediaLocale.MediaAudioText,
	[MediaSlot.AudioBackground]: MediaLocale.MediaAudioBackgroundText,
	[MediaSlot.OfflineVideo]: MediaLocale.MediaOfflineVideoText,
	[MediaSlot.StreamingVideo]: MediaLocale.MediaStreamingVideoText,
	[MediaSlot.TeacherManual]: MediaLocale.MediaTeacherManualText,
	[MediaSlot.Thumbnail]: MediaLocale.MediaThumbnailText,
	[MediaSlot.Image]: MediaLocale.MediaImageText,
	[MediaSlot.IndividualAudio]: MediaLocale.MediaIndividualAudioText
};

export const MediaTypeBinding = {
	[MediaType.PDF]: MediaLocale.MediaTypePdf,
	[MediaType.MP3]: MediaLocale.MediaTypeMp3,
	[MediaType.MP4]: MediaLocale.MediaTypeMp4,
	[MediaType.PNG]: MediaLocale.MediaTypePng
};

export const GridColumnBinding = {
	MediaSlot: "mediaSlot",
	FileType: "fileType",
	Exists: "existsValue"
};

export const MediaSlotFileSizeBinding = {
	[MediaSlot.ViewingContent]: 25 * 1024 * 1024, // 25 MB
	[MediaSlot.AlternateContent]: 25 * 1024 * 1024, // 25 MB
	[MediaSlot.Audio]: 25 * 1024 * 1024, // 25 MB
	[MediaSlot.AudioBackground]: 25 * 1024 * 1024, // 25 MB
	[MediaSlot.OfflineVideo]: 5 * 1024 * 1024 * 1024, // 5 GB
	[MediaSlot.StreamingVideo]: 5 * 1024 * 1024 * 1024, // 5 GB
	[MediaSlot.TeacherManual]: 25 * 1024 * 1024, // 25 MB
	[MediaSlot.Thumbnail]: 5 * 1024 * 1024 // 5 MB
};

export const MediaUploadTempFolder = "Temp";
